import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable, Input, Directive } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { HttpService } from './http.service';
import { LegacyBookInitService } from './legacy-book-initializer.service';
import { environment } from 'environments/environment';

@Directive()
@Injectable()
export class CurrencyService {
  server_name: string;
  errorMessage: string;
  public assetsURL: string;
  private messageSource = new BehaviorSubject<string>('USD');
  currentMessage = this.messageSource.asObservable();
  cloudBackendDomain: string = '';
  currencyCode: string;
  configUrl: any;
  tenantId: any;
  propertyId: any;
  APIContext: string;
  propertyname_config: string;

  changeMessage(message: string) {
    this.messageSource.next(message);
  }

  @Input() currency: object;
  constructor(private _http: HttpClient, public httpService: HttpService, public configservice: LegacyBookInitService) {
    this.server_name = configservice.PropertyData.UrlMap.CurrencyConverterUrl;
    this.assetsURL = configservice.PropertyData.UrlMap.AssetsUrl;
    this.configUrl = configservice.configUrl;
    this.tenantId = configservice.tenantId;
    this.propertyId = configservice.propertyId;
    this.propertyname_config = configservice.PropertyData.PropNameKeyList.config;
    this.APIContext = configservice.PropertyData.ContextId;
    this.currencyCode = configservice.PropertyData.currencyCode;
    this.cloudBackendDomain = configservice.getCloudDomainName();
  }
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      return of(result as T);
    };
  }
  getCurrency(): Observable<any[] | ArrayBuffer> {
    // let url = this.server_name;
    let url =
      this.cloudBackendDomain +
      '/' +
      this.configUrl +
      '/tenants/' +
      this.tenantId +
      '/propertyId/' +
      this.propertyId +
      '/baseCurrency/' +
      this.currencyCode;
    return this.httpService.get(url, this.configservice.serviceHeaders).pipe(
      tap((data) => console.log(data)),
      catchError(this.handleError('getOffers', []))
    );
  }
  private errorHandle = (error) => {
    console.log(error);
    this.errorMessage = error.ErrorMessage;
  };

  pushCurrency(currency) {
    this.currency = currency;
  }
}
